import { render, staticRenderFns } from "./RegisteredProductAdd.vue?vue&type=template&id=3df82bd0"
import script from "./RegisteredProductAdd.vue?vue&type=script&lang=js"
export * from "./RegisteredProductAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports